const nameOptions = [
	{
		id: '1',
		name: '李倩茹'
	},
	{
		id: '2',
		name: '33'
	},
	{
		id: '3',
		name: '44'
	},
	{
		id: '4',
		name: '66'
	},
	{
		id: '5',
		name: '77'
	},
	{
		id: '6',
		name: '88'
	}
]

export { nameOptions }
